import React from 'react';
import { message, Tooltip } from 'antd';
import { Project } from 'osep-generator-service-client-v1';
import { LinkOutlined } from '@ant-design/icons';

type Props = {
  project: Project;
};

const OpenPipeline = ({ project }: Props) => {
  const openPipeline = () => {
    if (project && project.generations && project.generations[0]) {
      const pipelineUrl = project.generations[0].pipelineUrl;
      if (pipelineUrl) {
        window.open(pipelineUrl, '_blank');
      } else {
        message.error('Pipeline URL not available.');
      }
    } else {
      message.error('Project generation data are missing.');
    }
  };

  return (
    <Tooltip title="Open Pipeline">
      <LinkOutlined
        type="primary"
        onClick={openPipeline}
        disabled={
          !project.generations ||
          !project.generations[0] ||
          !project.generations[0].pipelineUrl
        }
      />
    </Tooltip>
  );
};

export default OpenPipeline;
